import { render, staticRenderFns } from "./CardAction.vue?vue&type=template&id=fb461f3a&scoped=true"
import script from "./CardAction.vue?vue&type=script&lang=js"
export * from "./CardAction.vue?vue&type=script&lang=js"
import style0 from "./CardAction.vue?vue&type=style&index=0&id=fb461f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb461f3a",
  null
  
)

export default component.exports